import { render, staticRenderFns } from "./OrgNoData.vue?vue&type=template&id=2f0f0d14&scoped=true"
import script from "./OrgNoData.vue?vue&type=script&lang=js"
export * from "./OrgNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f0d14",
  null
  
)

export default component.exports